import React, {useCallback} from "react";
import {connect} from "react-redux";
import {
    DialogActions,
    DialogContent,
    DialogTitle, List, ListItem, ListItemAvatar, ListItemText, Alert, Chip,
    useMediaQuery,
    useTheme,
    Button,
    Avatar,
} from "@mui/material";
import {workspaceActions} from "../../store/actions/workspaceAction";
import {SettingsDialog as Dialog, SettingsDialogDescription, settingsSelectionListStyles} from "../settings/SettingsDialog";
import {SettingsEmptyState, getSettingsColors} from "../settings/SettingsDesign";
import {alertActions} from "../../store/actions/alertActions";
import {Person, Add} from "@mui/icons-material";

export function AssignUsers(props) {
    const {assignUserToWorkspace, error} = props;
    const {alert, user, workspace} = props.state;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleAssignUser = (u) => {
        const workspaceId = parseInt(props?.match?.params?.id);
        if (parseInt(workspaceId) === 0) {
            error("Workspace ID is missing.");
            return false;
        }
        assignUserToWorkspace({userId: u?.id, workspaceId: workspaceId, user: u});
    };

    const handleAlreadyAssignUser = (id) => {
        let res = false;
        workspace?.workspaceUsers?.filter((u) => {
            if (u?.id === id) {
                res = true;
            }
            return u;
        });
        return res;
    };

    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        props.history.push({pathname: "/settings/team/workspaces", state: {from: props.location}});
    }, [props]);

    return <Dialog open onClose={handleClose} fullWidth fullScreen={fullScreen} maxWidth="sm" aria-labelledby="assign-workspace-members">
        <DialogTitle id="assign-workspace-members">Assign workspace members
            <SettingsDialogDescription>Choose the team members who can access this workspace.</SettingsDialogDescription>
        </DialogTitle>
        <DialogContent>
            {alert.errorMsg && <Alert severity="error" variant="filled" sx={{mb: 2}}>{alert.errorMsg}</Alert>}
            <List sx={settingsSelectionListStyles} aria-label="Team members">
                {user?.users?.map(item => {
                    const assigned = handleAlreadyAssignUser(item.id);
                    return <ListItem key={item.id} sx={{gap: 1, px: 1.5, py: 1.5, alignItems: 'center', flexWrap: {xs: 'wrap', sm: 'nowrap'}}}>
                        <ListItemAvatar sx={{minWidth: 44}}><Avatar sx={{width: 32, height: 32,
                            bgcolor: theme => getSettingsColors(theme).input, color: 'text.secondary'}}><Person sx={{fontSize: 20}}/></Avatar></ListItemAvatar>
                        <ListItemText primary={item.email} sx={{minWidth: 0, flex: '1 1 180px'}}/>
                        {assigned ? <Chip label="Assigned" color="primary" size="small" variant="outlined"/> :
                            <Button size="small" startIcon={<Add/>} variant="outlined" onClick={() => handleAssignUser(item)}
                                aria-label={`Assign ${item.email} to workspace`}>Assign</Button>}
                    </ListItem>;
                })}
                {!user?.users?.length && <SettingsEmptyState icon={Person} title="No members available" description="Invite a team member to assign workspace access."/>}
            </List>
        </DialogContent>
        <DialogActions><Button onClick={handleClose} color="inherit">Done</Button></DialogActions>
    </Dialog>;
}

const mapStateToProps = (state) => {
    return {
        state: {
            workspace: state.workspace,
            alert: state.alert,
            user: state.user,
        }
    }
};

const mapDispatchToProps = {
    assignUserToWorkspace: workspaceActions.assignUserToWorkspace,
    error: alertActions.error,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignUsers);